import { formatDate } from '@msaf/core-common'
import { DISPLAY_DATETIME_FORMAT, DISPLAY_DATE_FORMAT } from '../constants'

export const formatDisplayDate = (date: string | Date | undefined) => formatDate(date, DISPLAY_DATE_FORMAT)

export const formatDisplayDateTime = (date: string | Date | undefined) => formatDate(date, DISPLAY_DATETIME_FORMAT)
